export default __webpack_public_path__ + "static/media/image32.e603112e.jpg";